import SysNotice from "widget/notice/dialogNotice/SysNotice";
import AbnormalNotice from "widget/notice/dialogNotice/AbnormalNotice";
import OrderUpdNotice from "widget/notice/dialogNotice/OrderUpdNotice";
import NCSNotice from "widget/notice/dialogNotice/NCSNotice";

import moment from "moment";
// 消息枚举
import { EReadStatus, ECollectStatus } from "utils/enum/notice";

// 模板消息
export default (data, swid, syncClose) => {
  // 消息创建日期
  // data.createTime = moment(parseInt(data.create_time) * 1000).format(
  //   "YYYY-MM-DD"
  // );

  const nowDate = moment();
  const dataDate = moment(parseInt(data.create_time) * 1000);
  const formatStr =
    nowDate.year > dataDate.year ? "YYYY-MM-DD HH:mm" : "MM-DD HH:mm";

  data.createTime = dataDate.format(formatStr);

  // 未读
  data.isRead = data.is_read ? EReadStatus.Yes : EReadStatus.No;
  // 未收藏
  data.isCollect = data.is_collection ? ECollectStatus.Yes : ECollectStatus.No;
  // // 消息级别
  // data.isNoticeLevel = !!data.isPopup
  //   ? ENoticeLevel.Importance
  //   : ENoticeLevel.General;
  // 订单号
  data.orderNumber = data.orderNumer;
  // 消息发送者
  data.from = data.from;
  data.swId = swid;

  // 系统登录通知
  if (data.type == 1 && data.isPopup && (!data.to && !data.from)) {
    SysNotice.show(data, syncClose);
  } else if (data.type == 2) {
    // 异常订单
    AbnormalNotice.show(data, syncClose);
  } else if (data.type == 3) {
    // 满员订单
    OrderUpdNotice.show(data, syncClose);
  } else if (data.type == 1 && data.from) {
    // 客服消息  xxx@你
    NCSNotice.show(data, syncClose);
  }
};
